import { useServiceTable } from "./useServiceTable";
import secondaryComponents from "../..";
import Images from "../../../../assets/images";
import styles from "./styles.module.scss";
import { RoutedModal } from "../../../common";
import { DeleteProduct } from "../DeleteProduct";

export const ServiceTable = ({
  services = [],
  metaDetails = {},
  gotoPage = () => {},
  ...rest
}) => {
  const { instance, selectedService, setSelectedService } = useServiceTable({
    services,
    ...rest,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        classNames={styles.serviceTable}
        hasAction={true}
      >
        <div className="pt-5 text-center">
          <img src={Images.productsEmptyState} width="250px" alt="" />
          <h4>You have no services </h4>
          <p>
            Use the button above to create a service When you do, they would
            appear here.
          </p>
        </div>
      </secondaryComponents.TableHelper>

      {/* pagination */}
      {services?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
            perPage={metaDetails?.per_page}
            unit="services"
          />
        </div>
      )}

      <RoutedModal
        isActive={!!selectedService}
        width={500}
        headerTitle="Delete Service"
        closeModal={() => setSelectedService(null)}
        style={{ height: "auto" }}
      >
        <DeleteProduct
          selectedItem={selectedService}
          closeModal={() => setSelectedService(null)}
        />
      </RoutedModal>
    </>
  );
};
